import { type FC } from 'react'

import './_fixedBottomButton.scss'

const FixedBottomButton: FC<{
  src?: string
  alt?: string
  text: string
  clickFn?: () => void
  customClass?: string
  disabled?: boolean
  secondaryText?: string
  secondaryClickFn?: () => void
}> = ({
  src,
  alt,
  text,
  clickFn,
  customClass,
  disabled,
  secondaryText,
  secondaryClickFn
}) => {
  const hasSecondaryButton = Boolean(secondaryText)

  return (
    <div
      className={`fixedbb-wrapper ${
        hasSecondaryButton ? 'fixedbb-wrapper--multiple' : ''
      } ${customClass || ''}`}
    >
      {hasSecondaryButton && (
        <button
          type='button'
          className='fixedbb fixedbb--secondary'
          onClick={secondaryClickFn}
        >
          {secondaryText}
        </button>
      )}

      <button
        type='button'
        className={`fixedbb fixedbb--primary ${
          disabled ? 'fixedbb--disabled' : ''
        }`}
        onClick={clickFn}
        disabled={disabled}
      >
        {src && <img src={src} alt={alt || ''} />}

        {text}
      </button>
    </div>
  )
}

export default FixedBottomButton